/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { use, useEffect } from 'fierry/react';

import Navigation from 'solis/navigation';
import Routes from 'solis/enum/route';


export default () =>
{
  const dispatch = use(Navigation.Dispatch);

  useEffect(() =>
  {
    dispatch.pushForeground({ route: Routes.Dashboard });
  }, []);

  return null;
};
